<template>
<div>
   <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container-fluid">
         <div class="row">
            <div class="col-12">
               <div class="row">
                  <div class="col-lg-12 col-xl-12">
                     <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                        <div class="card-header align-items-center  border-bottom-dark px-0">
                           <div class="card-title mb-0">
                              <h3 class="card-label mb-0 font-weight-bold text-body">
                                 {{this.$route.params.id ? 'Изменить' : 'Добавить'}} Товар
                              </h3>
                           </div>
                           <div class="icons d-flex" v-if="this.$route.params.id">
                              <button
                                 class="btn ml-2 p-0 d-none"
                                 @click="showActivityLog"
                                 data-toggle="tooltip"
                                 title="История изменений"
                                 data-placement="left">
                                 <span class="h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle shadow-sm">
                                    <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-clock-history" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                       <path fill-rule="evenodd" d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"/>
                                       <path fill-rule="evenodd" d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"/>
                                       <path fill-rule="evenodd" d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"/>
                                    </svg>
                                 </span>
                              </button>
                           </div>
                        </div>
                        <div class="card-body pb-0 pt-4 ">
                           <div class="d-flex justify-content-center">
                              <ul class="nav nav-pills mb-0" id="pills-tabmain" role="tablist">
                                 <li class="nav-item">
                                    <a class="nav-link" @click.prevent="setActive('info-tab')" :class="{ active: isActive('info-tab') }" href="#info-tab">
                                       <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-file-earmark-text" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"></path>
                                          <path d="M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z"></path>
                                          <path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
                                       </svg>
                                       Общая информация
                                    </a>
                                 </li>
                                 <li class="nav-item">
                                    <a class="nav-link" @click.prevent="setActive('ad-info-tab')" :class="{ active: isActive('ad-info-tab') }" href="#ad-info-tab">
                                       <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-receipt" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                          <path fill-rule="evenodd" d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z"></path>
                                          <path fill-rule="evenodd" d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"></path>
                                       </svg>
                                       Дополнительная информация
                                    </a>
                                 </li>
<!--                                 <li class="nav-item">-->
<!--                                    <a class="nav-link" @click.prevent="setActive('seo-tab')" :class="{ active: isActive('seo-tab') }" href="#seo-tab">-->
<!--                                       <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-receipt" fill="currentColor" xmlns="http://www.w3.org/2000/svg">-->
<!--                                          <path fill-rule="evenodd" d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z"></path>-->
<!--                                          <path fill-rule="evenodd" d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"></path>-->
<!--                                       </svg>-->
<!--                                       SEO-->
<!--                                    </a>-->
<!--                                 </li>-->
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="row">
                  <div class="col-lg-12 col-xl-12">
                     <div class="tab-content" id="pills-tabContent">
                     <div class="tab-pane fade" :class="{ 'active show': isActive('info-tab') }">
                        <BasicInfo @setCategoryInChild="setCategory" @setTitleInChild="setTitle" @setDescInChild="setDesc" @setGallaryIdInChild="setGallaryId"  @setActiveInChild="setActiveFromChild" @isActiveInChild="isActiveFromChild" @setVideoUrlInChild="setVideoUrl" @updateImageList="updateImageList" :errors="errors" :product="product" :edit="edit"></BasicInfo>
                        </div>
                        <div class="tab-pane fade" :class="{ 'active show': isActive('ad-info-tab') }">
                        <AdvanceInfo
                            @setUnitInChild="setUnit"
                            @setProductWeightInChild="setProductWeight"
                            @setBrandInChild="setBrand"
                            @setCollectionInChild="setCollection"
                            @setProductMaxOrderInChild="setProductMaxOrder"
                            @setProductMinOrderInChild="setProductMinOrder"
                            @setPriceInChild="setPrice"
                            @setPriceWithVatInChild="setPriceWithVat"
                            @setB2bPriceInChild="setB2bPrice"
                            @setDiscountPriceInChild="setDiscountPrice"
                            @setDiscountEndAtInChild="setDiscountEndAt"
                            @setProductTypeInChild="setProductType"
                            @setProductStatusInChild="setProductStatus"
                            @setProductStatusEEInChild="setProductStatusEE"
                            @setIsFeaturedInChild="setIsFeatured"
                            @setIsPointsInChild="setIsPoints"
                            :errors="errors"
                            @addProductInChild="addProduct"
                            @setActiveInChild="setActiveFromChild"
                            @isActiveInChild="isActiveFromChild"
                            @setAttributesInChild="setAttributes"
                            @setVariationsInChild="setVariations"
                            @unsetVariationInChild="unsetVariation"
                            @setCombinationPriceInChild="setCombinationPrice"
                            @setCombinationGalleryInChild="setCombinationGallery"
                            @setCombinationSkuInChild="setCombinationSku"
                            :product="product"
                            :edit="edit"
                            @setProductSkuInChild="setSku"
                            @setProductEanInChild="setEan"
                            @setBarcode="setBarcode"
                            @setPackageWidth="setPackageWidth"
                            @setPackageHeight="setPackageHeight"
                            @setPackageLength="setPackageLength"
                            @setPackageWeight="setPackageWeight"
                            @setItemWidth="setItemWidth"
                            @setItemHeight="setItemHeight"
                            @setItemLength="setItemLength"
                            @setItemWeight="setItemWeight"
                            @setTaxId="setTaxId"
                            @setAvailabilityStatus="setAvailabilityStatus"
                            @setExcludeParcel="setExcludeParcel"
                            @setCombinations="setCombinations"
                            @setPurchasePriceInChild="setPurchasePrice"
                            @setAvailableQuantityInChild="setAvailableQuantity"
                        />
                        </div>
<!--                        <div class="tab-pane fade" :class="{ 'active show': isActive('seo-tab') }">-->
<!--                        <Seo :product="product" :edit="edit" :errors="errors" @setSeoMetaTagInChild="setSeoMetaTag" @setSeoDescInChild="setSeoDesc" @setActiveInChild="setActiveFromChild" @isActiveInChild="isActiveFromChild" @addProductInChild="addProduct" />-->
<!--                        </div>-->
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>

   <!-- Activity Log Modal -->
   <ActivityLogModal
      ref="activityLogModal"
      model-type="product"
      :model-id="this.$route.params.id"
   />
</div>
</template>

<script>
import ErrorHandling from "./../../ErrorHandling";
import BasicInfo from './product/BasicInfo';
import Seo from './product/Seo';
import AdvanceInfo from './product/AdvanceInfo';
import ActivityLogModal from './ActivityLogModal';

export default {
     components: {
        BasicInfo,
        AdvanceInfo,
        Seo,
        ActivityLogModal,
    },
    data() {
        return {
            activeItem: 'info-tab',
            product: {
                'opencart_id': null,
                'category_id':[],
                'cat_id':[],
                'title':[],
                'desc':[],
                'language_id':[],
                'video_url':'',
                'product_unit':'',
                'product_weight':'',
                'brand_id':'',
                'product_min_order':1,
                'product_max_order':5,
                'price':'0',
                'price_with_vat':'0',
                'discount_price':'0',
                'discount_end_at': '',
                'product_type':'',
                'product_status':'active',
                'product_status_ee':'active',
                'is_featured':1,
                'is_points':1,
                'seo_meta_tag':'',
                'seo_desc':'',
                'attributes':[],
                'title_lang':[],
                'desc_lang':[],
                'languages': [],
                'images': [],
                'combination': {},
                'combination_detail': [],
                'sku':'',
                'barcode': '',
                'package_width': '',
                'package_height': '',
                'package_length': '',
                'package_weight': '',
                'item_width': '',
                'item_height': '',
                'item_length': '',
                'item_weight': '',
                'tax_id': '',
                'availability_status': '',
                'exclude_parcel': 1,
                'last_purchase' : {}
            },
            request_method : '',
            edit:false,
            token: [],
            errors: new ErrorHandling(),
            variationData:{},
            isSaveImages: false,
            copy: false,
        };
    },
    methods: {
        isActive(menuItem) {
            return this.activeItem === menuItem
        },
        setActive(menuItem) {
            this.activeItem = menuItem
        },
        setCategory(value,type){
           if(type === 'push'){
              if(this.product.category_id.indexOf(value) === -1){
                  this.product.category_id.push(value);
               }
           }
           else if(type === 'remove'){
               if(this.product.category_id.indexOf(value) !== -1){
                  this.product.category_id.splice(this.product.category_id.indexOf(value),value);
               }
           }

        },
        setTitle(value, index){
            this.product.title[index] = value;
        },
        setDesc(value, index){
           this.product.desc[index] = value;
        },
        setGallaryId(value){
           console.log(value);
           this.product.gallary_id = value[0];
           this.product.gallary_detail_id = value;
        },
        setVideoUrl(value){
           this.product.video_url = value;
        },
        setCombinations(value){
            this.product.combinations = value;
            console.log('save')
        },
        setActiveFromChild(value){
           this.activeItem = value
        },
        isActiveFromChild(value){
           return this.activeItem === value
        },
        setUnit(value){
           this.product.product_unit = value;
        },
        setProductWeight(value){
           this.product.product_weight = value;
        },
        setBrand(value){
           this.product.brand_id = value;
        },
        setCollection(value){
           this.product.collection_id = value;
        },
        setProductMinOrder(value){
           this.product.product_min_order = value;
        },
        setProductMaxOrder(value){
           this.product.product_max_order = value;
        },
        setPrice(value){
           this.product.price = value;
        },
        setPriceWithVat(value){
           this.product.price_with_vat = value;
        },
        setB2bPrice(value){
           // Null means "back to the brand factor", and has to survive being
           // sent: it is the way a product is taken off a hand-set price.
           this.product.b2b_price = (value === '' || typeof value === 'undefined') ? null : value;
        },
        setSeoMetaTag(value){
           this.product.seo_meta_tag = value;
        },
        setSeoDesc(value){
           this.product.seo_desc = value;
        },
        setDiscountPrice(value){
           this.product.discount_price = value;
        },
        setDiscountEndAt(value){
           this.product.discount_end_at = value;
        },
        setProductType(value){
           this.product.product_type = value;
        },
        setProductStatus(value){
           this.product.product_status = value == true || value == 'true' ? 'inactive' : 'active';
        },
        setProductStatusEE(value){
           this.product.product_status_ee = value == true || value == 'true' ? 'inactive' : 'active';
        },
        setIsFeatured(value){
           this.product.is_featured = value == true || value == 'true' ? 0 : 1;
        },
        setIsPoints(value){
           this.product.is_points = value == true || value == 'true' ? 0 : 1;
        },
        setAvailabilityStatus(value){
           this.product.availability_status = value;
        },
        setExcludeParcel(value){
           this.product.exclude_parcel = value == true || value == 'true' ? 1 : 0;
        },
        setPurchasePrice(value){
           this.product.purchase_price = value;
        },
        setAvailableQuantity(value){
           this.product.available_quantity = value;
        },
        setAttributes(value){
           if(this.product.attributes.indexOf(value) < 0){
              this.product.attributes.push(value);
           }
        },
        setVariations(name, value){
           this.product[name] = value;
        },
        unsetVariation(name){
           delete this.product[name];
        },
        setCombinationPrice(name, value){
         //   alert(value+'  '+name);
           this.product[name] = value;
        },
        setCombinationGallery(name, value){
           this.product[name] = value;
        },
        setCombinationSku(name, value){
         //   alert(value+'  '+name);
           this.product[name] = value;
        },
        updateImageList(fd){
            this.isSaveImages = true;
            this.product.images = fd
        },
        addProduct() {
            if(this.product.combinations && this.product.combinations.length){
                this.product.combinations.forEach((item) => {
                    if(item.discount_price === ''){
                        delete item.discount_price;
                    }
                })
            }
            console.log('UPDAETE')
            console.log(this.product)
            this.$parent.loading = true;
            var url = '/api/admin/product';

            /*this.product.title = this.product.title.filter(function (el) {
               console.log(el,"title")
               return el != null;
            });
            this.product.desc = this.product.desc.filter(function (el) {
               console.log(el,"desc")
               return el != null;
            });*/

            if (this.edit === false) {
                // Add
                this.request_method = 'post'
            } else {
                // Update
                var url = '/api/admin/product/' + this.$route.params.id;
                this.request_method = 'put';
                this.product['edit'] = "yes";
            }
            const form_data = new FormData();

            for ( const key in this.product ) {
                form_data.append(key, this.product[key]);
            }
            const imagesSave = this.product.images;
            this.product.images = [];
            this.product.tax_id = 2; //21%
            this.product.tax_rate = '21';
            axios[this.request_method](url, this.product, this.token)
                .then(res => {
                    if (res.data.status == "Success" && this.isSaveImages) {
                        axios.post(`/api/admin/product/${res.data.data.product_id}/images`, imagesSave, this.token).then(() => {
                            // this.display_form = 0;
                            this.$toaster.success(res.data.message);
                            axios.post(`/api/admin/product/${res.data.data.product_id}/product-created`, imagesSave, this.token).then(() => {
                                setTimeout(() => { this.$router.push('/admin/products'); }, 1000);
                            })
                        })
                    } else {
                        this.$toaster.error(res.data.message)
                    }
                })
                .catch(error => {
                    this.product.images = imagesSave;
					this.error_message = '';
					this.errors = new ErrorHandling();
					if (error.response.status == 422) {
						if(error.response.data.status == 'Error'){
							// this.error_message = error.response.data.message;
                     this.$toaster.error(error.response.data.message)
						}
						else{

                     console.log(error.response.data.errors);
                     const propertyNames = Object.keys(error.response.data.errors);
                     propertyNames.forEach(key => {
                        this.$toaster.error(error.response.data.errors[key][0]);
                     });
							this.errors.record(error.response.data.errors);

						}
					}
				}).finally(() => (this.$parent.loading = false));

        },
        fetchProduct(id) {
            this.$parent.loading = true;
            var page_url = "/api/admin/product/"+id+"?getCategory=1&getDetail=1";

            var responseData = {};

            axios.get(page_url, this.token).then(res => {
                if(!this.copy) {
                    this.edit = true;
                }

               this.product.seo_meta_tag = res.data.data.seo_meta_tag;
               this.product.seo_desc = res.data.data.seo_desc;
               this.product.sku = res.data.data.product_sku;
               // A copy is a new product: it gets its own shop product, not
               // the original's link.
               this.$set(this.product, 'opencart_id', this.copy ? null : (res.data.data.opencart_id || null));
               this.product.images = res.data.data.images;
               this.product.is_points = res.data.data.is_points == '' || res.data.data.is_points == null ? 0 : 1;
               this.product.video_url = res.data.data.product_video_url;
               this.product.product_unit = res.data.data.product_unit == null ? '' : res.data.data.product_unit.id;
               this.product.item_height = res.data.data.product_item_height;
               this.product.item_width = res.data.data.product_item_width;
               this.product.item_length = res.data.data.product_item_length;
               this.product.item_weight = res.data.data.product_item_weight;
               this.product.package_height = res.data.data.product_package_height;
               this.product.package_width = res.data.data.product_package_width;
               this.product.package_length = res.data.data.product_package_length;
               this.product.package_weight = res.data.data.product_package_weight;
               this.product.product_min_order = res.data.data.product_min_order;
               this.product.product_max_order = res.data.data.product_max_order;
               this.product.price = parseFloat(res.data.data.product_price);
               this.product.price_with_vat = parseFloat(res.data.data.product_price_with_vat);
               this.product.b2b_price = res.data.data.product_b2b_price ?? null;
               this.product.ean = res.data.data.product_ean,
               this.product.barcode = res.data.data.product_barcode,
               this.product.discount_price = parseFloat(res.data.data.product_discount_price);
               this.product.discount_end_at = res.data.data.discount_end_at || '';
               this.product.product_type = res.data.data.product_type;
               this.product.product_status = res.data.data.product_status;
               this.product.product_status_ee = res.data.data.product_status_ee;
               this.product.brand_id = res.data.data.product_brand == null ? '' : res.data.data.product_brand.brand_id;
               this.product.collection_id = res.data.data.product_collection == null ? '' : res.data.data.product_collection.id;
               this.product.tax_id = res.data.data.product_tax_id == null ? '' : res.data.data.product_tax_id;
               this.product.tax = res.data.data.product_tax;
               this.product.availability_status = res.data.data.product_availability_status;
               this.product.last_purchase = res.data.data.last_purchase;
               this.product.exclude_parcel = res.data.data.exclude_parcel;
               this.product.stocks = res.data.data.stocks;
               this.product.available_quantity = res.data.data.available_qty || 0;

               if(res.data.data.category != null){
                  for(var i =0; i < res.data.data.category.length; i++){
                     this.product.category_id.push(res.data.data.category[i].category_detail.id);
                     this.product.cat_id.push(res.data.data.category[i].category_detail);
                  }
               }
               if(res.data.data.detail != null){
                  for(var i = 0; i < res.data.data.detail.length; i++){
                     this.product.title.push(res.data.data.detail[i].title);
                     this.product.desc.push(res.data.data.detail[i].desc);
                     this.product.title_lang.push(res.data.data.detail[i].title);
                     this.product.desc_lang.push(res.data.data.detail[i].desc);
                    
                     this.product.languages.push(res.data.data.detail[i].language.id);
                  }
                  console.log(this.product.title)
               }
               if(res.data.data.product_gallary_detail != null){
                  for(var i = 0; i < res.data.data.product_gallary_detail.length; i++){
                     if(i==0){
                        this.product.gallary_id = res.data.data.product_gallary_detail[i].id;
                     }
                     this.product.gallary_detail_path.push('/gallary/'+res.data.data.product_gallary_detail[i].gallary_name);
                     this.product.gallary_detail_id.push(res.data.data.product_gallary_detail[i].id);
                  }
               }
               if(res.data.data.product_type == 'variable'){
                  for(var i=0; i < res.data.data.combination.length; i++){
                     this.product.attributes.push(res.data.data.combination[i].attributes.attribute_id);
                        this.product.combination[res.data.data.combination[i].attributes.attribute_id] = res.data.data.combination[i];
                  }
               }

               if(res.data.data.product_type == 'variable'){
                  for(var i=0; i < res.data.data.combination_detail.length; i++){
                        this.product.combination_detail[i] = res.data.data.combination_detail[i];
                  }
               }




               this.product = Object.assign({}, this.product, { is_featured: res.data.data.is_featured })
            }).finally(() => (this.$parent.loading = false));

            //     'attributes':[]
        },
        setSku(value){
           this.product.sku = value;
        },
        setBarcode(value){
            this.product.barcode = value;
        },
        setPackageWidth(value){
            this.product.package_width = value;
        },
        setPackageHeight(value){
            this.product.package_height = value;
        },
        setPackageLength(value){
            this.product.package_length = value;
        },
        setPackageWeight(value){
            this.product.package_weight = value;
        },
        setItemWidth(value){
            this.product.item_width = value;
        },
        setItemHeight(value){
            this.product.item_height = value;
        },
        setItemLength(value){
            this.product.item_length = value;
        },
        setItemWeight(value){
            this.product.item_weight = value;
        },
        setTaxId(value){
            this.product.tax_id = value;
            this.product.tax_id = 2;
        },
        setEan(value){
            this.product.ean = value;
        },
      //   getLastSku() {
      //       this.$parent.$parent.loading = true;
      //       var token = localStorage.getItem('token');
      //       const config = {
      //           headers: {
      //               Authorization: `Bearer ${token}`
      //           }
      //       };
      //       var responseData = {};

      //       axios.post('/api/admin/product/sku',{},config)
      //           .then(res => {
      //               if (res.data.status == "Success") {
      //                   this.product = Object.assign({}, this.product, { sku: res.data.data})
      //               }
      //           })
      //           .finally(() => (this.$parent.$parent.loading = false));

      //   },

        showActivityLog() {
            if (this.$refs.activityLogModal) {
                this.$refs.activityLogModal.show();
            }
        },

    },
    mounted() {

        var token = localStorage.getItem('token');
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        if(this.$route.params.id){
           this.fetchProduct(this.$route.params.id);
        } else if(this.$route.params.copyid) {
            this.fetchProduct(this.$route.params.copyid);
            this.copy = true;
        }

      //   this.getLastSku();

    }
};
</script>
